import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const TrashCheckIcon = createIcon({
  displayName: 'TrashCheckIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,0H24V24H0Z" fill="none" />
      <ellipse
        cx="12"
        cy="5.5"
        rx="8"
        ry="2.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.98952,5.628s-1.18388,8.55121-1.72509,12.46157a2.98359,2.98359,0,0,1-2.32514,2.52123,20.13038,20.13038,0,0,1-7.87882,0A2.98359,2.98359,0,0,1,5.7354,18.08956C5.1942,14.17924,4.01031,5.62794,4.01031,5.62794"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.75,13l-2,2L10.5,13.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const TrashCheck: FC<IconProps> = (props) => {
  return <CustomIcon as={TrashCheckIcon} {...props} />
}

export default memo(TrashCheck)
